module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1297.b3ebe222.png";